import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { MailingRequest } from 'src/app/core/interfaces/customer/mailing-requests';
import { ApiService } from 'src/app/core/services/api/api.service';

@Component({
  selector: 'app-mailing-requests-count-list',
  templateUrl: './mailing-requests-count-list.component.html',
  styleUrls: ['./mailing-requests-count-list.component.scss'],
})
export class MailingRequestsCountListComponent implements OnInit {
  displayedColumns: string[] = [
    'customerName',
    'customerAddress',
    'customerEmail',
    'email',
    'mail',
    'notes',
  ];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  mailingRequestArray: MailingRequest[] = [];
  dataSource: MatTableDataSource<MailingRequest>;

  isLoading: boolean = true;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();
    // this.getAppointments(this.apptStatus);
    this.route.paramMap.subscribe((params) => {
      this.getMailingRequests();
    });
  }

  getMailingRequests() {
    this.isLoading = true;
    this.dataSource = new MatTableDataSource();

    // Need this api call
    this.apiService.getOpenMailingRequests().subscribe({
      next: (mailingRequests) => {
        this.isLoading = false;
        this.mailingRequestArray = mailingRequests;
        this.dataSource = new MatTableDataSource(this.mailingRequestArray);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      error: (e) => {
        this.isLoading = false;
        console.error(e);
      },
    });
  }

  goToMailingRequest(row: MailingRequest) {
    this.router.navigate(['customers/' + row.customerId], {
      queryParams: {
        jobAddressId: row.jobAddressId,
        mailingRequest: true,
      },
    });
  }

  filterMailingRequests(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
